/**
 * @generated — manual edits won't persist!
 * Shim sources: platform/build/monorepo-utils/deprecation-removal-recovery/index.js
 * Regenerate: node platform/build/monorepo-utils/deprecation-removal-recovery/generate-shims.js
 */
const original = require('../../../../packages/design-system/theme/src/constants.tsx');

module.exports = Object.assign({}, original, {
	gridSize: () => 8,
	borderRadius: () => 3,
	fontSize: () => 14,
	fontSizeSmall: () => 11,
});

if (original.__esModule) Object.defineProperty(module.exports, '__esModule', { value: true });
